// Upgrades the cart add-on forms (snippets/cart-addons.liquid) to add in place via Shopify's
// standard cart action, which the theme already listens to for re-rendering the drawer and cart page.
// Without JS or Shopify.actions, the forms fall back to a normal /cart/add post.
document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('[data-cart-addon-form]')) return;

  const updateCart = window.Shopify?.actions?.updateCart;
  if (!updateCart) return;

  event.preventDefault();

  const button = form.querySelector('button');
  if (button?.getAttribute('aria-busy') === 'true') return;
  button?.setAttribute('aria-busy', 'true');

  try {
    const variantId = new FormData(form).get('id');
    const result = await updateCart({ lines: [{ merchandiseId: String(variantId), quantity: 1 }] });
    if (result?.userErrors?.length) console.warn('[cart-addons]', result.userErrors);
  } catch (error) {
    console.error('[cart-addons]', error);
  } finally {
    button?.removeAttribute('aria-busy');
  }
});
